module.exports = __webpack_public_path__ + "img/left-icon.3e064b19.jpg";